const routes = [
  {
    name: 'mapping',
    path: '/mapping',
    component: () => import('@/pages/mapping/Index.vue')
  }
]

export default routes
